import React, { useState, useEffect, useMemo } from 'react'
import { gql, useLazyQuery } from '@apollo/client'
import { Paragraph, MoreLess } from '@fs/zion-ui'
import Cache from '@fs/zion-cache'
import { usePermission } from '@fs/zion-permissions'

const getOlibNotes = gql`
  query getOlibNotes($groupId: String) {
    olibNotes(groupId: $groupId)
  }
`

const storeName = 'lightyear_additionalData'
const olibNotesKey = 'lightyear_storedOlibNotes'

export default function OlibNotes({ groupId = null }) {
  const [fetchOlibNotes] = useLazyQuery(getOlibNotes)
  const [notes, setNotes] = useState([])
  const cache = useMemo(() => new Cache({ storeName }), [])
  const [hasRMSGroupReadPermission] = usePermission('RMSGroupReadPermission', 'RMSContext')

  useEffect(() => {
    async function f() {
      if (groupId) {
        const cachedData = await cache.getItem(olibNotesKey)
        if (cachedData && cachedData?.id === groupId) setNotes(cachedData.notes)
        else if (hasRMSGroupReadPermission) {
          try {
            const { data } = await fetchOlibNotes({ variables: { groupId } })
            const resolvedNotes = Array.from(new Set(data?.olibNotes || []))
            setNotes(resolvedNotes)

            cache.setItem(olibNotesKey, { id: groupId, notes: data?.olibNotes || [] })
          } catch (error) {
            console.error(error)
            setNotes([])
          }
        }
      }
    }

    f()
    return () => setNotes([])
  }, [fetchOlibNotes, groupId, cache, hasRMSGroupReadPermission])

  return (
    <>
      {!notes?.length && '-'}
      {groupId && notes && (
        <MoreLess collapsedLineCount={5}>
          <Paragraph size="sm">
            {notes.map((n, i) => {
              return (
                <React.Fragment key={n}>
                  {i > 0 && (
                    <>
                      <br />
                      <br />
                    </>
                  )}
                  {n}
                </React.Fragment>
              )
            })}
          </Paragraph>
        </MoreLess>
      )}
    </>
  )
}
